export default "__VITE_ASSET__NH0r6mQG__"